<template>
  <div class="theme">
    <ul class="theme-list">
      <li v-for="(theme, themeIndex) in themes" :key="themeIndex">
        <span class="theme-name">{{theme.name}}</span>
        <div class="flex">
          <ul class="colors">
            <li
              class="edit-color"
              v-for="(sectionStyle, index) in theme.sectionStyles"
              :key="index"
              :style="{ background: sectionBackground(sectionStyle) }"
            />
          </ul>
          <div class="theme-control">
            <button class="w-b-btn" @click="applyTheme(theme)">選択</button>
            <button class="w-b-btn" @click="deleteThemeConfirm(theme)">削除</button>
          </div>
        </div>
      </li>
    </ul>
    <portal v-if="isShowDeletePopup" to="modal1">
      <modal @close="isShowDeletePopup = false">
        <template slot="title">削除確認</template>
        <template slot="name">"{{trimThemeName(deletingTheme.name)}}"を本当に削除してもよろしいでしょうか?</template>
        <template slot="submit">
          <div class="button-box">
            <button type="button" @click="deleteTheme" class="delete normal-btn">削除</button>
            <button type="button" @click="isShowDeletePopup = false" class="cancel normal-btn">キャンセル</button>
          </div>
        </template>
      </modal>
    </portal>
  </div>
</template>
<script>
import Modal from '@/components/Util/Modal'
export default {
  name: 'content-design-themes',
  components: {
    Modal,
  },
  data () {
    return {
      isShowDeletePopup: false,
      deletingTheme: {},
    }
  },
  computed: {
    themes () {
      return this.$store.getters.getThemes
    },
    sectionBackground (style) {
      return (style) => style['background'] || 'unset'
    },
    themeNum () {
      return this.$store.getters.getThemeNum
    },
  },
  methods: {
    applyTheme (theme) {
      const sections = this.$store.getters.getSectionAll.map(section => {
        return {
          ...section,
          styles: { ...theme.sectionStyles[section.name] }
        }
      })
      this.$store.commit('updateSections', sections)
      this.$store.commit('updateStyles', theme.contentStyles)
      let self = this
      theme.contentMobileStyles.forEach(obj => {
        self.$store.commit('updateMobileStyles', {
          selector: obj.selector,
          styles: [{
            prop: obj.prop,
            value: obj.value,
          }]
        })
      })
    },
    deleteThemeConfirm (theme) {
      this.isShowDeletePopup = true
      this.deletingTheme = theme
    },
    deleteTheme () {
      this.$http({
        url: '/theme/delete/' + this.deletingTheme.id,
        type: 'POST',
      }).then(json => {
        if (json && json.status === 200) {
          const newThemes = this.themes.filter(theme => theme.id !== this.deletingTheme.id)
          this.$store.commit('updateThemes', newThemes)
          this.$store.commit('updateThemeNum', {
            max: this.themeNum.max,
            current: this.themes.length
          })
          this.isShowDeletePopup = false
        }
      })
    },
    trimThemeName (themeName) {
      // テーマ名が30文字より大きい場合、30文字で切り出す
      return themeName.length > 30 ? themeName.substr(0, 30) + '…' : themeName
    }
  },
}
</script>
<style lang="scss" scoped>
.colors {
  .edit-color {
    width: 24px;
    height: 24px;
    display: inline-block;
    border: #dbdbdb 0.5px solid;
    border-radius: 2px;
    margin-right: 5px;
    &:last-of-type {
      margin-right: 0;
    }
  }
}
.theme-list {
  line-height: 1;
  > li {
    display: flex;
    flex-direction: column;
    span {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .theme-name {
    height: 30px;
    line-height: 30px;
  }
  .flex {
    display: flex;
    justify-content: space-between;
    .w-b-btn {
      box-sizing: border-box;
      border: 1px solid #dbdbdb;
      &:nth-of-type(1) {
        color: $commonFontColor;
        background: #fff;
        &:hover {
          background: #e4e4e4;
        }
      }
      &:nth-of-type(2) {
        background: $errorColor;
        margin-left: 10px;
        &:hover {
          background: $errorHoverColor;
        }
      }
    }
  }
}
// モーダルの中身
.button-box {
  display: flex;
  justify-content: center;
  button {
    font-size: 14px;
    border: solid 1px #c6c6c6;
    border-radius: 5px;
    &:hover {
      opacity: 0.8;
    }
    &.delete {
      margin-right: 20px;
      color: #fff;
      border: solid 1px #484848;
      background: #484848;
    }
  }
}
</style>
